(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ps-montageservice"]) return;
  try {
    

function initMontageService(){
const root=document.getElementById('ps-montageservice');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const count=root.querySelector('#ps-count'),km=root.querySelector('#ps-km');root.querySelector('.ps-inputs').hidden=false;
const money=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'});
function update(){const n=Number(count.value),d=Number(km.value);const valid=count.value!==''&&km.value!==''&&Number.isFinite(n)&&Number.isFinite(d)&&Number.isInteger(n)&&n>=6&&d>=0;root.querySelector('#ps-error').hidden=valid;root.querySelector('#ps-result').hidden=!valid;count.setAttribute('aria-invalid',String(!(Number.isInteger(n)&&n>=6&&count.value!=='')));km.setAttribute('aria-invalid',String(!(Number.isFinite(d)&&d>=0&&km.value!=='')));if(!valid)return;const total=n*85+d*.8;root.querySelector('#ps-labor').textContent=money.format(n*85);root.querySelector('#ps-travellabel').textContent=root.querySelector('#ps-travellabel').dataset.travelLabel.replace('{km}',new Intl.NumberFormat('nl-NL').format(d*2));root.querySelector('#ps-travel').textContent=money.format(d*.8);root.querySelector('#ps-total').textContent=money.format(total);root.querySelector('#ps-vat').textContent=money.format(total*1.21)}
count.addEventListener('input',update);km.addEventListener('input',update);update();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initMontageService)}else{initMontageService()}
document.addEventListener('shopify:section:load',initMontageService);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-reformer-keuzehulp"] && !Shopify.designMode) return;
  try {
    

(function(){
'use strict';
const esc=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const nums=value=>(String(value??'').match(/\d+(?:[.,]\d+)?/g)||[]).map(n=>Number(n.replace(',','.')));
function measurement(value){if(!value||!Number(value.value))return null;const n=Number(value.value),u=String(value.unit).toLowerCase();if(u.includes('pound'))return n*.45359237;if(u.includes('inch'))return n*2.54;if(u==='meters')return n*100;if(u.includes('millimeter'))return n/10;return n;}
function dimensions(value){const m=String(value??'').match(/(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)(?:\s*[×x]\s*(\d+(?:[.,]\d+)?))?/i);return m?m.slice(1).map(n=>n?Number(n.replace(',','.')):null):[null,null,null];}
function normalize(raw){
 const title=raw.title||'',handle=raw.handle||'',other=raw.other||'',all=title+' '+handle;
 const size=dimensions(raw.dimensions),bed=nums(raw.bed),audience=String(raw.audience||'');
 const footbarLine=other.split('\n').find(x=>/breedte inclusief footbar/i.test(x));if(footbarLine)size[1]=Math.max(size[1]||0,nums(footbarLine)[0]||0);
 const collapsedLine=other.split('\n').find(x=>/afmetingen ingeschoven/i.test(x));
 const collapsed=collapsedLine?dimensions(collapsedLine):[null,null,null];
 const uprightLine=other.split('\n').find(x=>/afmetingen rechtop/i.test(x));
 let uprightHeight=uprightLine?dimensions(uprightLine)[2]:null;
 if(handle==='elina-pilates-vertical-reformer-for-home')uprightHeight=235;
 const heightLimitLine=other.split('\n').find(x=>/geschikte lichaamslengte/i.test(x));
 const heightLimit=heightLimitLine?nums(heightLimitLine)[0]:null;
 const base={...raw,home:/Thuisgebruik/i.test(audience),professional:/Professioneel/i.test(audience),length:size[0],width:size[1],height:bed.length===1?bed[0]:null,max:measurement(raw.maxWeight),ceiling:measurement(raw.totalHeight)||size[2],full:/met.tower|reformer.trapeze|cadillac/i.test(all),mini:!!raw.mini,mega:/megaformer/i.test(all),classic:/pilates.classic.reformer|elina.classic.reformer/i.test(all),special:/pilates.twin.reformer/i.test(all),towerLater:/later uitbreidbaar/i.test(raw.tower||''),collapsed,uprightHeight,maxUserHeight:heightLimit?(heightLimit<3?heightLimit*100:heightLimit):null};
 if(base.special)base.full=true;
 return(raw.variants||[]).filter(v=>v.price>0).map(v=>{
  const p={...base,available:v.available,variant:v.title,variantId:String(v.id),price:Number(v.price),image:v.image||raw.image,url:raw.url+'?variant='+encodeURIComponent(v.id)};
  if(/^HL[1-4]$/.test(v.title)){
   const line=other.split('\n').find(x=>x.startsWith(v.title+','))||'';
   p.height=nums(line.match(/carriagehoogte\s+([\d,.]+)\s*cm/i)?.[1])[0]||null;
   p.ceiling=nums(line.match(/(?:totale|maximale) hoogte\s+([\d,.]+)\s*cm/i)?.[1])[0]||null;
  }
  if(handle==='balanced-body-allegro-2-reformer')p.height=/zonder/i.test(v.title)?23:/met/i.test(v.title)?38:null;
  if(/zonder box/i.test(v.title))p.box=false;else if(/met box/i.test(v.title))p.box=true;
  if(handle==='elina-pilates-domo-reformer'){p.box=/met box/i.test(v.title);p.jump=/jumpboard/i.test(v.title);}
  if(handle==='balanced-body-studio-reformer'){p.foot=/Infinity/i.test(v.title)?'Infinity':/Klassiek/i.test(v.title)?'Classic':raw.foot;}
  return p;
 });
}
function criteria(p,a){
 const failed=[];
 if(a.use==='home'?!p.home:!p.professional)failed.push('audience');
 if(Boolean(a.lesson==='mega')!==p.mega)failed.push('training');
 if(Boolean(a.clinical==='split')!==p.special)failed.push('special');
 if(p.classic)failed.push('method');
 if(a.clinical!=='split'&&a.lesson!=='mega'){
  if(a.tower==='now'&&!p.full)failed.push('tower');
  if(a.tower!=='now'&&p.full)failed.push('no_tower');
  if(a.tower==='later'&&!p.towerLater)failed.push('upgrade');
 }
 if(a.storage==='upright'&&!/verticaal|rechtop/i.test(p.storage||''))failed.push('storage');
 if(a.storage==='compact'&&!/inklapbaar|telescopisch/i.test(p.storage||''))failed.push('storage');
 if(a.storage==='under'&&!(/horizontaal/i.test(p.storage||'')&&/telescopisch/i.test(p.storage||'')))failed.push('storage');
 if(a.storage==='stack'&&(!/stapelbaar/i.test(p.storage||'')||/zonder tower/i.test(p.storage||'')))failed.push('storage');
 if(a.clinical==='high'&&!(p.height>=48&&p.height<=61))failed.push('height');
 const weight=+a.weightKg||(['heavy','both'].includes(a.body)?121:0);
 if(weight){if(!p.max)failed.push('weight_unknown');else if(p.max<weight)failed.push('weight');}
 if(['tall','both'].includes(a.body)&&p.maxUserHeight&&p.maxUserHeight<=190)failed.push('user_height');
 return failed;
}
function score(p,a){let n=0;
 if(a.priority==='value')n+=(p.box?6:0)+(p.jump?6:0);
 if(a.priority==='adjust'&&/infinity|quick release/i.test(p.foot||''))n+=10;
 if(a.priority==='wood'&&/hout|maple|beech/i.test(p.frame||''))n+=10;
 if(a.frequency==='daily'){if(p.professional)n+=5;if(/infinity|quick release/i.test(p.foot||''))n+=3;}
 if(['group','both'].includes(a.lesson)&&/infinity|quick release/i.test(p.foot||''))n+=4;
 if(a.use==='physio'&&/physio|fysio/i.test(p.title))n+=3;
 if(a.use!=='home'&&a.clinical!=='high'&&p.height>=35&&p.height<=45)n+=2;
 if(a.tower==='later'&&p.towerLater)n+=2;
 return n;
}
function penalty(p,a){const weights={audience:3000,training:3000,special:3000,method:1200,tower:240,no_tower:240,upgrade:150,storage:120,height:180,weight_unknown:800,weight:10000,user_height:10000};return criteria(p,a).reduce((n,k)=>n+weights[k],0);}
function rank(products,answers){
 const available=products.filter(p=>p.available!==false),pool=available.length?available:products;
 const sorted=pool.map(p=>({...p,unmatched:criteria(p,answers)})).sort((a,b)=>penalty(a,answers)-penalty(b,answers)||score(b,answers)-score(a,answers)||a.price-b.price);
 const exact=sorted.filter(p=>!p.unmatched.length),seen=new Set();
 return (exact.length?exact:sorted).filter(p=>{if(seen.has(p.id))return false;seen.add(p.id);return true;});
}
function routeKeys(a){
 const keys=['use'];if(!a.use)return keys;
 if(a.use==='studio')keys.push('lesson');if(a.use==='physio')keys.push('clinical');
 keys.push('frequency','storage');
 if(a.lesson!=='mega'&&a.clinical!=='split')keys.push('tower');
 keys.push('body');if(['heavy','both'].includes(a.body))keys.push('weight');
 keys.push('priority');return keys;
}
function init(root){
 if(root.dataset.initialized)return;
 let data;try{data=JSON.parse(root.querySelector('[data-psq-data]').textContent);if(!Array.isArray(data.products)||!data.copy||!data.questions)throw new Error('Invalid data');}catch(e){const message=root.querySelector('[data-psq-load-error]');if(message)message.hidden=false;return;}
 root.dataset.initialized='true';
 const text=data.copy,questions=data.questions,stage=root.querySelector('[data-psq-stage]'),introTemplate=root.querySelector('[data-psq-intro]');
 const products=data.products.flatMap(normalize),currency=data.currency||'EUR';
 const number=n=>new Intl.NumberFormat(document.documentElement.lang||'nl-NL',{maximumFractionDigits:1}).format(n);
 const euro=n=>new Intl.NumberFormat(document.documentElement.lang||'nl-NL',{style:'currency',currency}).format(n/100);
 const t=(key,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',v),text[key]||'');
 let answers={},currentKey='use';
 const question=key=>{const raw=questions[(answers.use||'home')+'_'+key]||questions['studio_'+key];return raw&&{...raw,title:t(raw.title),hint:t(raw.hint),opts:raw.opts?.map(([v,l,d])=>[v,t(l),t(d)]),fields:raw.fields?.map(([v,l])=>[v,t(l)])};};
 const route=()=>routeKeys(answers).map(question).filter(Boolean);
 function afterRender(){const heading=stage.querySelector('h1');if(!heading)return;heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});const top=root.getBoundingClientRect().top;if(top<100||top>window.innerHeight/2)root.scrollIntoView({behavior:'auto',block:'start'});}
 function save(k,v,extra={}){
  if(k==='use'&&answers.use!==v)answers={};
  const cur=question(k);for(const [key]of cur?.fields||[])delete answers[key];
  answers={...answers,...extra,[k]:v};
  const active=new Set(routeKeys(answers));
  for(const key of ['lesson','clinical','tower','weight'])if(!active.has(key)){delete answers[key];if(key==='weight')delete answers.weightKg;}
  const list=route();currentKey=list[list.findIndex(q=>q.key===k)+1]?.key||'results';render();afterRender();
 }
 function back(){const list=route(),index=currentKey==='results'?list.length:list.findIndex(q=>q.key===currentKey);currentKey=list[Math.max(0,index-1)].key;render();afterRender();}
 function reset(){answers={};currentKey='use';render();afterRender();}
 const purpose=()=>t((answers.use||'home')+'_purpose');
 function render(){
  const list=route(),cur=list.find(x=>x.key===currentKey);
  if(currentKey==='results'||!cur){stage.dataset.psqStep='results';renderResults();return;}
  stage.dataset.psqStep=cur.key;
  if(cur.key==='use'){
   stage.innerHTML=introTemplate.innerHTML;
   stage.querySelectorAll('[data-answer]').forEach(b=>{b.disabled=false;b.setAttribute('aria-pressed',String(b.dataset.answer===answers.use));b.addEventListener('click',()=>save('use',b.dataset.answer));});return;
  }
  const position=list.indexOf(cur)+1,last=position===list.length;
  stage.innerHTML=`<div class="question-bar"><span>${esc(t('label'))}</span><span>${esc(purpose())}<i class="divider" aria-hidden="true"></i>${esc(t('question_count',{current:position,total:list.length}))}</span></div><section class="question-layout"><div class="question-copy"><h1>${esc(cur.title)}</h1><p>${esc(cur.hint)}</p></div><form class="psq-form" aria-label="${esc(cur.title)}" novalidate autocomplete="off">${cur.opts?`<fieldset class="answers"><legend class="psq-sr-only">${esc(t('choose'))}</legend>${cur.opts.map(([v,l,d])=>`<label class="answer"><input type="radio" name="psanswer-${esc(cur.key)}" data-ps-answer value="${esc(v)}" ${answers[cur.key]===v?'checked':''}><span class="answer-copy"><span class="answer-title">${esc(l)}</span>${d?`<small>${esc(d)}</small>`:''}</span></label>`).join('')}</fieldset>`:`<div class="fields">${cur.fields.map(([k,l])=>`<label class="field" for="${esc(root.id+'-'+k)}">${esc(l)}<input id="${esc(root.id+'-'+k)}" name="${esc(k)}" inputmode="decimal" type="number" min="1" max="1000" step="any" value="${esc(answers[k]??'')}"></label>`).join('')}</div>`}<p id="${esc(root.id+'-error')}" class="error" role="alert"></p><div class="question-controls"><button type="submit" class="primary">${esc(t(last?'show_results':'next'))}<span aria-hidden="true">→</span></button><button type="button" data-skip class="secondary skip-button">${esc(t('skip'))}</button></div><p class="skip-hint">${esc(t('skip_hint'))}</p><button type="button" class="back-button" data-back><span aria-hidden="true">←</span> ${esc(t('previous'))}</button></form></section>`;
  const form=stage.querySelector('form'),error=form.querySelector('.error');
  function showError(message,input){error.textContent=message;if(input){input.setAttribute('aria-invalid','true');input.setAttribute('aria-describedby',error.id);input.focus();}}
  function submit(e){
   e.preventDefault();e.stopPropagation();
   if(cur.opts){const checked=form.querySelector('[data-ps-answer]:checked');if(!checked){showError(t('choose'),form.querySelector('[data-ps-answer]'));return;}save(cur.key,checked.value);return;}
   const extra={};
   for(const [key]of cur.fields){const input=form.elements.namedItem(key);if(!input.validity.valid){showError(t('invalid'),input);return;}if(input.value!=='')extra[key]=Number(input.value);}
   save(cur.key,Object.keys(extra).length?true:'unknown',extra);
  }
  form.addEventListener('change',()=>{error.textContent='';form.querySelectorAll('[aria-invalid]').forEach(el=>{el.removeAttribute('aria-invalid');el.removeAttribute('aria-describedby');});});
  form.addEventListener('input',()=>{error.textContent='';});
  form.addEventListener('submit',submit);
  form.querySelector('[type="submit"]').addEventListener('click',submit);
  stage.querySelector('[data-back]').addEventListener('click',back);
  stage.querySelector('[data-skip]').addEventListener('click',()=>save(cur.key,'unknown'));
 }
 function reasons(p){const a=answers,r=[],failed=new Set(p.unmatched);
  if(!failed.has('audience'))r.push(t(a.use==='home'?'reason_home':'reason_pro'));
  if(a.storage&&a.storage!=='fixed'&&a.storage!=='unknown'&&!failed.has('storage'))r.push(t('reason_storage_'+a.storage));
  if(a.clinical==='high'&&p.height&&!failed.has('height'))r.push(t('reason_height',{value:number(p.height)}));
  if(a.tower==='now'&&p.full)r.push(t('reason_tower'));
  if(a.tower==='later'&&p.towerLater)r.push(t('reason_later'));
  if(a.priority==='wood'&&/hout|maple|beech/i.test(p.frame||''))r.push(t('reason_wood'));
  if((a.priority==='adjust'||a.frequency==='daily')&&/infinity|quick release/i.test(p.foot||''))r.push(t('reason_footbar'));
  if(p.box&&p.jump)r.push(t('reason_box_jump'));else if(p.box)r.push(t('reason_box'));else if(p.jump)r.push(t('reason_jump'));
  if((a.weightKg||['heavy','both'].includes(a.body))&&p.max&&!failed.has('weight'))r.push(t('reason_weight',{value:number(p.max)}));
  if(a.frequency==='daily'&&a.use==='home'&&p.professional)r.push(t('reason_daily'));
  return [...new Set(r)];
 }
 function differences(p){return p.unmatched.map(k=>{
  const value=k==='storage'?p.storage:k==='height'?(p.height?number(p.height)+' cm':t('height_variable')):k==='audience'?p.audience:k==='weight'?number(p.max):k==='user_height'?number(p.maxUserHeight):'';
  return t('difference_'+k,{value});
 }).filter(Boolean);}
 function facts(p){const a=answers,r=[];
  if(p.length&&p.width)r.push(t('model_size',{length:number(p.length),width:number(p.width)}));
  if(p.height)r.push(t('model_bed',{value:number(p.height)}));
  if(a.storage==='under'&&p.collapsed.every(Boolean))r.push(t('model_storage_size',{length:number(p.collapsed[0]),width:number(p.collapsed[1]),height:number(p.collapsed[2])}));
  if(a.storage==='upright'&&p.uprightHeight)r.push(t('model_storage_height',{value:number(p.uprightHeight)}));
  if(p.handle==='balanced-body-allegro-2-reformer'&&a.storage==='upright')r.push(t('note_wheels'));
  if(p.mini)r.push(t('note_mini'));
  if(p.full&&a.storage&&a.storage!=='fixed'&&a.storage!=='unknown')r.push(t('note_tower_storage'));
  if(p.available===false)r.push(t('model_unavailable'));
  return r;
 }
 function renderResults(){
  const a=answers,all=rank(products,a),selected=all.slice(0,3),has=selected.length,approximate=has&&selected[0].unmatched.length;
  stage.innerHTML=`<section class="result-intro"><h1>${esc(t(has?'result_title':'empty_title'))}<br><em>${esc(t(has?'result_highlight':'empty_highlight'))}</em></h1><p>${esc(t(has?(approximate?'result_fallback':'result_intro'):'empty_intro'))}</p></section><div class="result-summary"><span>${esc(purpose())}${a.storage&&a.storage!=='unknown'?`<span>·</span>${esc(t(a.storage))}`:''}</span><span>${esc(t('result_basis'))}</span></div>${has?`<div class="results" data-count="${selected.length}">${selected.map((p,i)=>{const notes=differences(p),modelFacts=facts(p),review=p.unmatched.some(k=>['weight','weight_unknown','user_height','audience','training','special'].includes(k))||p.available===false;return `<article class="product"><a class="product-image" href="${esc(p.url)}"><span class="product-tag">${esc(t(i===0?'suggestion':'also'))}</span><img src="${esc(p.image)}" alt="${esc(p.title)}" width="640" height="640" loading="lazy"></a><div class="product-content"><h2><a href="${esc(p.url)}">${esc(p.title)}</a></h2>${p.variant!=='Default Title'?`<p class="meta">${esc(t('variant'))}: ${esc(p.variant)}</p>`:''}<p class="price">${euro(p.price)}</p><p class="meta">${esc(t('tax'))}</p><ul>${reasons(p).map(r=>`<li>${esc(r)}</li>`).join('')}</ul>${notes.length?`<div class="model-context"><p class="context-label">${esc(t('model_context'))}</p>${notes.map(n=>`<p>${esc(n)}</p>`).join('')}</div>`:''}<a class="primary" href="${esc(review?data.contact:p.url)}">${esc(t(review?'discussion_model':'view_product'))}</a>${modelFacts.length?`<div class="model-facts">${modelFacts.map(n=>`<p>${esc(n)}</p>`).join('')}</div>`:''}</div></article>`;}).join('')}</div><p class="result-footnote">${esc(t('exclusions'))}</p>${['tall','both'].includes(a.body)?`<p class="result-footnote">${esc(t('tall_advice'))}</p>`:''}`:`<div class="empty"><a class="primary" href="${esc(data.contact)}">${esc(t('empty_cta'))}</a></div>`}<div class="result-details"><details><summary>${esc(t('answers'))}</summary>${route().map(q=>`<p><strong>${esc(q.title)}</strong><br>${esc(q.opts?.find(x=>x[0]===a[q.key])?.[1]||q.fields?.map(([k,l])=>l+': '+(a[k]||t('not_filled'))).join(' · ')||t('not_filled'))}</p>`).join('')}</details></div><div class="result-actions"><button type="button" data-edit class="secondary">${esc(t('edit_answers'))}</button><button type="button" data-restart class="secondary">${esc(t('restart'))}</button></div>`;
  stage.querySelector('[data-restart]').addEventListener('click',reset);
  stage.querySelector('[data-edit]').addEventListener('click',()=>{currentKey=route()[1]?.key||'use';render();afterRender();});
 }
 render();
}
function boot(){document.querySelectorAll('[data-ps-choice]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
if(typeof module!=='undefined'&&module.exports)module.exports={normalize,criteria,rank,score,routeKeys,penalty};
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-studio-roi"] && !Shopify.designMode) return;
  try {
    
function psRoiEvaluate(v, mode) {
  const monthlyLessons = v.lessons * v.weeks / 12;
  const fullGroup = v.beds * monthlyLessons * v.price;
  const otherRevenue = (v.privateCount * v.privatePrice + v.duoCount * v.duoPrice) * v.weeks / 12;
  const teacherCost = monthlyLessons * v.teacher + (v.privateCount * v.privateCost + v.duoCount * v.duoCost) * v.weeks / 12;
  const outgoings = teacherCost + v.fixedTotal + v.owner;
  const margin = 1 - v.fees / 100;
  const revenue = fullGroup * v.occupancy / 100 + otherRevenue;
  const costs = outgoings + revenue * v.fees / 100;
  const profit = revenue - costs;
  const baseline = mode === 'existing' ? v.baseRevenue - v.baseCosts - v.baseOwner : 0;
  const investment = v.equipment + v.setup;
  const startRevenue = mode === 'existing' ? v.baseRevenue : fullGroup * v.startOccupancy / 100 + otherRevenue;
  let cumulative = 0, sum36 = 0, low12 = 0, payback = null;
  for (let month = 1; month <= 120; month++) {
    const weight = v.ramp <= 1 ? 1 : Math.min(1, (month - 1) / (v.ramp - 1));
    const monthlyRevenue = startRevenue + (revenue - startRevenue) * weight;
    cumulative += monthlyRevenue * margin - outgoings - baseline;
    if (month <= 12) low12 = Math.min(low12, cumulative);
    if (month === 36) sum36 = cumulative;
    if (investment > 0 && payback === null && cumulative >= investment) payback = month;
  }
  const uncovered = outgoings - otherRevenue * margin;
  const breakEven = uncovered <= 0 ? 0 : fullGroup * margin > 0 ? uncovered / (fullGroup * margin) * 100 : null;
  const scenario = (occupancy) => (fullGroup * occupancy / 100 + otherRevenue) * margin - outgoings;
  return {revenue, costs, profit, delta:profit - baseline, investment, roi:investment > 0 ? (sum36 - investment) / investment * 100 : null, payback, breakEven, bufferNeeded:-low12, funding:investment + v.buffer, low:scenario(Math.max(0, v.occupancy - 15)), high:scenario(Math.min(100, v.occupancy + 15)), sum36};
}

if (!customElements.get('ps-studio-roi')) {
  customElements.define('ps-studio-roi', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.inputs = [...this.querySelectorAll('[data-roi-number]')];
      this.copy = Object.fromEntries([...this.querySelectorAll('[data-roi-text]')].map(el => [el.dataset.roiText, el.textContent]));
      this.money = new Intl.NumberFormat('nl-NL', {style:'currency', currency:'EUR', maximumFractionDigits:0});
      this.number = new Intl.NumberFormat('nl-NL', {maximumFractionDigits:1});
      this.mode = 'new';
      this.step = 0;
      this.dirty = false;
      this.breakdown = this.querySelector('[data-roi-breakdown]');
      const initial = this.values();
      this.states = {new:{values:initial, breakdown:false, dirty:false}, existing:{values:{...initial,equipment:12000,setup:1000,ramp:3},breakdown:false,dirty:false}};
      this.inputs.forEach(input => input.addEventListener('input', () => {
        if (this.breakdown.checked && ['rent','utilities','software','marketing','maintenance'].includes(input.dataset.roiNumber)) this.syncCosts();
        this.dirty = true;
        this.update();
      }));
      this.querySelectorAll('[data-roi-mode]').forEach(button => button.addEventListener('click', () => this.setMode(button.dataset.roiMode)));
      this.querySelectorAll('[data-roi-step]').forEach(button => button.addEventListener('click', () => this.showStep(Number(button.dataset.roiStep))));
      this.querySelectorAll('[data-roi-next]').forEach(button => button.addEventListener('click', () => {
        const next = Number(button.dataset.roiNext);
        if (next > this.step && !this.checkPanel()) return;
        this.showStep(next);
      }));
      this.breakdown.addEventListener('change', () => {
        this.setBreakdown();
        if (this.breakdown.checked) this.syncCosts();
        this.dirty = true;
        this.update();
      });
      this.querySelector('[data-roi-show]').addEventListener('click', () => {
        const invalid = this.invalidInputs()[0];
        if (invalid) { this.revealInput(invalid); return; }
        this.querySelector('.ps-roi__result h3').focus();
        this.querySelector('.ps-roi__result').scrollIntoView({behavior:'auto',block:'start'});
      });
      this.setBreakdown();
      this.update(false);
    }
    disconnectedCallback() { clearTimeout(this.announceTimer); }
    values() { return Object.fromEntries(this.inputs.map(input => [input.dataset.roiNumber, Number(input.value)])); }
    field(name) { return this.querySelector('[data-roi-number="'+name+'"]'); }
    out(name, value) { this.querySelector('[data-roi-out="'+name+'"]').textContent = value; }
    setBreakdown() {
      this.querySelector('[data-roi-cost-fields]').hidden = !this.breakdown.checked;
      this.field('fixedTotal').disabled = this.breakdown.checked;
      ['rent','utilities','software','marketing','maintenance'].forEach(key => { this.field(key).disabled = !this.breakdown.checked; });
    }
    syncCosts() {
      const total = ['rent','utilities','software','marketing','maintenance'].reduce((sum, key) => sum + Number(this.field(key).value), 0);
      this.field('fixedTotal').value = Number.isFinite(total) ? Math.round(total * 100) / 100 : '';
    }
    invalidInputs() {
      return this.inputs.filter(input => {
        const key = input.dataset.roiNumber;
        if (input.disabled || (this.mode === 'new' && key.startsWith('base')) || (this.mode === 'existing' && key === 'startOccupancy')) return false;
        return !input.validity.valid;
      });
    }
    checkPanel() {
      const invalid = this.invalidInputs().find(input => input.closest('[data-roi-panel]').dataset.roiPanel === String(this.step));
      if (!invalid) return true;
      this.revealInput(invalid);
      return false;
    }
    revealInput(input) {
      this.showStep(Number(input.closest('[data-roi-panel]').dataset.roiPanel));
      const detail = input.closest('details');
      if (detail) detail.open = true;
      input.focus();
      input.reportValidity();
    }
    showStep(step) {
      this.step = step;
      this.querySelectorAll('[data-roi-panel]').forEach(panel => { panel.hidden = Number(panel.dataset.roiPanel) !== step; });
      this.querySelectorAll('[data-roi-step]').forEach(button => {
        if (Number(button.dataset.roiStep) === step) button.setAttribute('aria-current','step');
        else button.removeAttribute('aria-current');
      });
      this.querySelector('[data-roi-panel="'+step+'"] h3').focus({preventScroll:true});
      if (window.matchMedia('(max-width: 767px)').matches) this.querySelector('.ps-roi__steps').scrollIntoView({behavior:'auto',block:'start'});
    }
    setMode(next) {
      if (next === this.mode) return;
      this.states[this.mode] = {values:Object.fromEntries(this.inputs.map(input => [input.dataset.roiNumber,input.value])),breakdown:this.breakdown.checked,dirty:this.dirty};
      this.mode = next;
      const state = this.states[next];
      this.inputs.forEach(input => { input.value = state.values[input.dataset.roiNumber]; });
      this.dirty = state.dirty;
      this.breakdown.checked = state.breakdown;
      this.setBreakdown();
      this.querySelectorAll('[data-roi-mode]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.roiMode === next)));
      this.querySelectorAll('[data-roi-new]').forEach(el => { el.hidden = next !== 'new'; });
      this.querySelectorAll('[data-roi-existing]').forEach(el => { el.hidden = next !== 'existing'; });
      this.showStep(0);
      this.update();
    }
    update(announce = true) {
      const invalid = this.invalidInputs();
      this.inputs.forEach(input => input.setAttribute('aria-invalid',String(invalid.includes(input))));
      this.querySelector('[data-roi-error]').hidden = invalid.length === 0;
      this.querySelector('[data-roi-badge]').textContent = this.copy[this.dirty ? 'personal' : 'example'];
      const warning = this.querySelector('[data-roi-warning]');
      warning.hidden = true;
      if (invalid.length) {
        this.querySelectorAll('[data-roi-out]').forEach(el => { el.textContent = '–'; });
        clearTimeout(this.announceTimer);
        return;
      }
      const v = this.values(), r = psRoiEvaluate(v, this.mode);
      ['revenue','costs','profit','delta','investment','funding','low','high'].forEach(key => this.out(key,this.money.format(r[key])));
      this.out('middle',this.money.format(r.profit));
      this.querySelector('[data-roi-out="profit"]').dataset.negative = String(r.profit < 0);
      this.out('payback',r.investment === 0 ? this.copy.not_applicable : r.payback === null ? this.copy.beyond : r.payback+' '+this.copy.months);
      this.out('roi',r.roi === null ? this.copy.not_applicable : Math.round(r.roi)+'%');
      this.out('breakEven',r.breakEven === null ? this.copy.not_possible : r.breakEven > 100 ? this.copy.above : Math.ceil(r.breakEven)+'%');
      this.out('bufferNote',(this.mode === 'existing' ? this.copy.buffer_existing : this.copy.buffer_new)+' '+this.money.format(r.bufferNeeded)+'. '+(v.buffer >= r.bufferNeeded ? this.copy.buffer_ok : this.copy.buffer_short+' '+this.money.format(r.bufferNeeded-v.buffer)+'.'));
      this.out('lowLabel',this.number.format(Math.max(0,v.occupancy-15))+'% '+this.copy.occupancy);
      this.out('middleLabel',this.number.format(v.occupancy)+'% '+this.copy.occupancy);
      this.out('highLabel',this.number.format(Math.min(100,v.occupancy+15))+'% '+this.copy.occupancy);
      if (r.profit < 0 || r.investment === 0) {
        warning.hidden = false;
        warning.textContent = [r.profit < 0 ? this.copy.loss : '', r.investment === 0 ? this.copy.no_investment : ''].filter(Boolean).join(' ');
      }
      if (announce) {
        clearTimeout(this.announceTimer);
        this.announceTimer = setTimeout(() => { this.querySelector('[data-roi-status]').textContent = this.copy.status+' '+this.querySelector('.ps-roi__metric--profit>span').textContent+': '+this.money.format(r.profit); },500);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-studio-room"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ps-studio-room')){
  customElements.define('ps-studio-room',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.dialog=this.querySelector('dialog');
      this.opener=this.querySelector('[data-room-open]');
      this.opener.hidden=false;
      this.addEventListener('click',event=>{
        const view=event.target.closest('[data-room-view]');
        if(view){
          this.querySelectorAll('[data-room-view]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.roomView===view.dataset.roomView)));
          this.querySelectorAll('[data-room-image]').forEach(img=>{img.hidden=img.dataset.roomImage!==view.dataset.roomView;});
        }
        if(event.target.closest('[data-room-open]')){this.dialog.showModal();this.querySelector('[data-room-close]').focus();}
        if(event.target.closest('[data-room-close]'))this.dialog.close();
        if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}
      });
      this.dialog.addEventListener('close',()=>this.opener.focus());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-zakelijk"] && !Shopify.designMode) return;
  try {
    


function psEvaluate(v,mode){
 const monthlyLessons=v.lessons*v.weeks/12;
 const fullGroup=v.beds*monthlyLessons*v.price;
 const otherRevenue=(v.privateCount*v.privatePrice+v.duoCount*v.duoPrice)*v.weeks/12;
 const teacherCost=monthlyLessons*v.teacher+(v.privateCount*v.privateCost+v.duoCount*v.duoCost)*v.weeks/12;
 const fixed=v.rent+v.utilities+v.software+v.marketing+v.maintenance;
 const outgoings=teacherCost+fixed+v.owner;
 const margin=1-v.fees/100;
 const revenue=fullGroup*v.occupancy/100+otherRevenue;
 const profit=revenue*margin-outgoings;
 const baseline=mode==='existing'?v.baseRevenue-v.baseCosts-v.baseOwner:0;
 const investment=v.equipment+v.setup;
 const startRevenue=mode==='existing'?v.baseRevenue:fullGroup*v.startOccupancy/100+otherRevenue;
 let cumulative=0,sum36=0,low12=0,payback=null;
 for(let month=1;month<=120;month++){
  const weight=v.ramp<=1?1:Math.min(1,(month-1)/(v.ramp-1));
  const monthlyRevenue=startRevenue+(revenue-startRevenue)*weight;
  const surplus=monthlyRevenue*margin-outgoings-baseline;
  cumulative+=surplus;
  if(month<=12)low12=Math.min(low12,cumulative);
  if(month===36)sum36=cumulative;
  if(investment>0&&payback===null&&cumulative>=investment)payback=month;
 }
 const breakEven=fullGroup*margin>0?Math.max(0,(outgoings-otherRevenue*margin)/(fullGroup*margin)*100):null;
 const scenario=(occupancy)=>(fullGroup*occupancy/100+otherRevenue)*margin-outgoings;
 return {revenue,profit,delta:profit-baseline,investment,roi:investment>0?(sum36-investment)/investment*100:null,payback,breakEven,bufferNeeded:-low12,funding:investment+v.buffer,fixed,low:scenario(Math.max(0,v.occupancy-15)),high:scenario(Math.min(100,v.occupancy+15)),sum36};
}
function psInitStudio(){
 const root=document.getElementById('ps-studio');
 if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
 const money=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR',maximumFractionDigits:0});
 const numbers=[...root.querySelectorAll('[data-n]')];
 const read=()=>Object.fromEntries(numbers.map(el=>{let n=Number(el.value);n=Number.isFinite(n)?Math.max(Number(el.min)||0,n):0;if(el.max)n=Math.min(Number(el.max),n);return[el.dataset.n,n]}));
 let mode='new';const states={new:read(),existing:{...read(),equipment:12000,setup:1000,ramp:3}};
 const out=(key,value)=>{root.querySelector('[data-out="'+key+'"]').textContent=value};
 function update(){const v=read(),r=psEvaluate(v,mode);out('profit',money.format(r.profit));out('revenue',money.format(r.revenue));out('delta',money.format(r.delta));out('breakEven',r.breakEven===null?'Niet berekenbaar':r.breakEven>100?'> 100%':Math.ceil(r.breakEven)+'%');out('payback',r.investment===0?'Niet van toepassing':r.payback===null?'Niet binnen 10 jaar':'Maand '+r.payback);out('roi',r.roi===null?'Niet van toepassing':Math.round(r.roi)+'%');out('funding',money.format(r.funding));out('costSummary',money.format(r.fixed+v.owner)+' + fees');out('investmentSummary',money.format(r.investment));out('bufferNote',(mode==='existing'?'Extra operationele buffer':'Operationele buffer')+' nodig in jaar 1: '+money.format(r.bufferNeeded)+'. '+(v.buffer>=r.bufferNeeded?'Je gekozen buffer dekt dit rekenkundige tekort.':'Je gekozen buffer is hiervoor '+money.format(r.bufferNeeded-v.buffer)+' te laag.'));out('lowLabel',Math.max(0,v.occupancy-15)+'% bezetting');out('middleLabel',v.occupancy+'% bezetting');out('highLabel',Math.min(100,v.occupancy+15)+'% bezetting');out('low',money.format(r.low));out('middle',money.format(r.profit));out('high',money.format(r.high));}
 function setMode(next){states[mode]=read();mode=next;numbers.forEach(el=>el.value=states[mode][el.dataset.n]);root.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode===mode)));root.querySelector('.ps-baseline').hidden=mode!=='existing';root.querySelector('.ps-added').hidden=mode!=='existing';root.querySelector('.ps-start-occupancy').hidden=mode==='existing';root.querySelector('[data-mode-heading]').textContent=mode==='existing'?'Jouw studio na de investering':'Jouw toekomstige studio';root.querySelector('[data-mode-help]').textContent=mode==='existing'?'Vergelijk je huidige studio met je plannen na de investering.':'Pas de voorbeeldbedragen aan jouw situatie aan.';root.querySelector('[data-invest-label]').textContent=mode==='existing'?'Alleen de nieuwe investering (€)':'Apparatuur en inrichting (€)';root.querySelector('[data-payback-label]').textContent=mode==='existing'?'Nieuwe investering terugverdiend':'Investering terugverdiend';update();}
 numbers.forEach(el=>{el.addEventListener('input',update);el.addEventListener('change',()=>{el.value=read()[el.dataset.n];update()})});root.querySelectorAll('[data-mode]').forEach(b=>b.addEventListener('click',()=>setMode(b.dataset.mode)));update();
 root.querySelectorAll('a[href^="#ps-"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();if(a.dataset.route)setMode(a.dataset.route);const target=document.querySelector(a.getAttribute('href'));if(target)target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})}));
}
function psInitRoom(){
 document.querySelectorAll('.ps-studio-design .ps-studio-visual').forEach(root=>{
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  root.querySelectorAll('[data-view]').forEach(button=>button.addEventListener('click',()=>{
   root.querySelector('.ps-room').classList.toggle('flat',button.dataset.view==='flat');
   root.querySelectorAll('[data-view]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  }));
 });
}
function psInitZakelijk(){psInitStudio();psInitRoom()}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',psInitZakelijk)}else{psInitZakelijk()}
document.addEventListener('shopify:section:load',psInitZakelijk);




  } catch(e) { console.error(e); }
})();
})();
